import { render } from "./TruckUpdates.vue?vue&type=template&id=55cec778&scoped=true"
import script from "./TruckUpdates.vue?vue&type=script&lang=js"
export * from "./TruckUpdates.vue?vue&type=script&lang=js"

import "./TruckUpdates.vue?vue&type=style&index=0&id=55cec778&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cec778"]])

export default __exports__